import React from 'react';
import PropTypes from 'prop-types';
export var LoadMoreProgress = function LoadMoreProgress(_ref) {
  var loaded = _ref.loaded,
    total = _ref.total;
  if (!loaded || !total) {
    return null;
  }
  var width = "".concat(loaded / total * 100, "%");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'text-center margin-bottom-3'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'text-medium'
  }, loaded), /*#__PURE__*/React.createElement("span", {
    className: 'margin-left-5 margin-right-5'
  }, '/'), /*#__PURE__*/React.createElement("span", {
    className: 'text-medium'
  }, total)), /*#__PURE__*/React.createElement("div", {
    className: 'progress bg-white height-2 margin-bottom-10'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'progress-bar',
    style: {
      width: width
    }
  })));
};
LoadMoreProgress.defaultProps = {
  loaded: 0,
  total: 0
};
LoadMoreProgress.propTypes = {
  loaded: PropTypes.number,
  total: PropTypes.number
};
export default LoadMoreProgress;